import actions from './actions'

const initialState = {
  messageLogs: [],
  messageLogsLoadMoreId: 0,
  messageLogsPollingId: 0,
  messageLogsLoading: false,
  messageCategories: [],
  messageCategoriesLoading: false,
  messageSearchLogs: [],
  messageSearchLogsLoading: false,
  messageSearchExceedsLimit: false,
  messageActive: [],
  messageExportLogs: [],
  messageExportLogsLoading: false,
  messageExportAllExceedsLimit: false,
  appMessageSettings: {},
  modMessageLogs: [],
  modMessageLogsLoadMoreId: 0,
  modMessageLogsLoading: false,
}

export default function messagesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
